"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLsosProject = void 0;
var assertUsage_1 = require("./utils/assertUsage");
var getExportName_1 = require("./utils/getExportName");
var propSourcesDefault = {
    npmName: "npmName",
    projectName: "projectName",
    donationText: "donationText",
    minNumberOfAuthors: "minNumberOfAuthors",
};
function validateLsosProject(_a, propSources) {
    var npmName = _a.npmName, projectName = _a.projectName, donationText = _a.donationText, minNumberOfAuthors = _a.minNumberOfAuthors;
    if (propSources === void 0) { propSources = propSourcesDefault; }
    assertUsage_1.assertUsage(npmName.split("/").length === 1, "The `npmName` argument should be the name of the organization on npm (`@org-name`). If there is no npm organization, then it should be the name of the package (`package-name`). In particular do not set `npmName` to `@org-name/package-name`, but set it to `@org-name` instead.");
    var argumentsMissing = [
        !npmName && propSources["npmName"],
        !projectName && propSources["projectName"],
        !donationText && propSources["donationText"],
    ].filter(Boolean);
    var errorPrefix = "[" + getExportName_1.getExportName() + "()] ";
    assertUsage_1.assertUsage(argumentsMissing.length === 0, errorPrefix +
        "Following arguments are missing: " +
        argumentsMissing.map(function (arg) { return "`" + arg + "`"; }).join(", ") +
        ".");
    assertUsage_1.assertUsage(minNumberOfAuthors === undefined || typeof minNumberOfAuthors === "number", errorPrefix + "`" + propSources.minNumberOfAuthors + "` should be a number");
}
exports.validateLsosProject = validateLsosProject;
//# sourceMappingURL=validateLsosProject.js.map